// Likes live only in this browser (localStorage); nothing is sent anywhere.
import Vue from 'vue';

const KEY = 'likes';

function load() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch (e) {
    return [];
  }
}

function save(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    // storage blocked (private mode, quota): likes then last until the page is closed
  }
}

const state = Vue.observable({ ids: load() });

// keep several open tabs in sync
window.addEventListener('storage', e => {
  if (e.key === KEY) state.ids = load();
});

export default {
  isLiked(id) {
    return state.ids.indexOf(id) !== -1;
  },
  // returns the new state (true = liked)
  toggle(id) {
    const next = state.ids.slice();
    const i = next.indexOf(id);
    if (i === -1) next.push(id); else next.splice(i, 1);
    state.ids = next;
    save(next);
    return i === -1;
  },
  count() {
    return state.ids.length;
  },
};
